import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, MessageCircle, X } from "lucide-react";
import { WA_TATTOO } from "../../lib/constants";

export const Lightbox = ({ items, index, onClose, onNav }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (index === null) return;
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav((index + 1) % items.length);
      if (e.key === "ArrowLeft") onNav((index - 1 + items.length) % items.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [index, items.length, onClose, onNav]);

  const item = index !== null ? items[index] : null;

  return (
    <AnimatePresence>
      {item && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
          className="fixed inset-0 z-[100] bg-[#0A0A0A]/95 backdrop-blur-md flex items-center justify-center p-6"
          data-testid="lightbox-overlay"
        >
          <button
            onClick={onClose}
            data-testid="lightbox-close-button"
            aria-label="Fechar"
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center border border-white/20 text-white hover:border-[#E60000] hover:text-[#E60000] transition-colors duration-300"
          >
            <X size={20} />
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); onNav((index - 1 + items.length) % items.length); }}
            data-testid="lightbox-prev-button"
            aria-label="Anterior"
            className="absolute left-4 lg:left-10 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center border border-white/20 text-white hover:border-[#E60000] hover:text-[#E60000] transition-colors duration-300"
          >
            <ChevronLeft size={22} />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onNav((index + 1) % items.length); }}
            data-testid="lightbox-next-button"
            aria-label="Próxima"
            className="absolute right-4 lg:right-10 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center border border-white/20 text-white hover:border-[#E60000] hover:text-[#E60000] transition-colors duration-300"
          >
            <ChevronRight size={22} />
          </button>

          <motion.div
            key={item.src}
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="max-w-3xl w-full flex flex-col items-center"
          >
            <img
              src={item.src}
              alt={item.title}
              className="max-h-[72vh] w-auto object-contain border border-white/10"
              data-testid="lightbox-image"
            />
            <div className="mt-6 flex flex-col sm:flex-row items-center gap-5 text-center">
              <div>
                <p className="text-[10px] tracking-[0.3em] font-bold text-[#E60000]">{item.tag}</p>
                <h3 className="font-display italic font-bold text-white text-2xl mt-1" data-testid="lightbox-title">{item.title}</h3>
              </div>
              <a
                href={WA_TATTOO}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="lightbox-whatsapp-button"
                className="btn-sharp inline-flex items-center gap-2 bg-[#E60000] hover:bg-white hover:text-[#0A0A0A] text-white text-xs tracking-[0.15em] font-extrabold px-6 py-3 transition-colors duration-300"
              >
                <MessageCircle size={14} /> QUERO UMA IDEIA ASSIM
              </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
